export default "__VITE_ASSET__4f7e9867__"